import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import DatePicker from "react-datepicker";
import Moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { getHistorySearchlist } from "../Actions/MMPLDashboardAPI";
import { Paginator } from "primereact/paginator";
import { toast } from "react-toastify";
import $ from "jquery";

const SearchItem = {
  minyear: "",
  maxyear: "",
  IsClient: false,
  SelectedFromDate: "",
  SelectedToDate: "",
  moduleName: "",
  actionBy: "",
  nextDateFrom: "",
  nextDateTo: "",
  pagesize: 25,
  pagenumber: 1,
  sortby: " ",
  sortorder: " ",
  first: 0,
};

class HistoryofActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Serialno: 0,
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      filterTitle: "Search History",
      SearchHistory: {
        minyear: "",
        maxyear: "",
        IsClient: false,
        moduleName: "",
        actionBy: "",
        nextDateFrom: "",
        nextDateTo: "",
        pagesize: 25,
        pagenumber: 1,
        sortby: " ",
        sortorder: " ",
        first: 0,
      },
    };
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.SearchHistory = this.SearchHistory.bind(this);
    this.ClearSearchField = this.ClearSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch } = nextProps;
    if (nextProps.mmplHistorySearchResult && nextProps.showSidePane) {
      prevState.searchhistoryitem = nextProps.mmplHistorySearchResult;
    }
    let updatedstate = {};
    const { match } = nextProps;
    const { params } = match;
    const { type } = params;
    if (prevState.type !== type) updatedstate.type = type;
    return updatedstate;
  }

  componentDidMount() {
    const { dispatch, mmplHistorySearchResult, t } = this.props;
    this.SearchHistory(1);
    dispatch({ type: "SubBannerTitle", data: "History of Actions" });
    let searchhistoryitem = this.state.SearchHistory;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if (_this.verifySearchItems()
      //   // searchhistoryitem.moduleName ||
      //   // searchhistoryitem.actionBy ||
      //   // searchhistoryitem.nextDateFrom ||
      //   // searchhistoryitem.nextDateTo
      // ) {
      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchHistory(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  SearchHistory(pgno) {
    this.state.SearchHistory["pagenumber"] = pgno;
    const { dispatch } = this.props;
    this.setState({ filterShiplist: true });
    dispatch(getHistorySearchlist(this.state.SearchHistory));
  }

  verifySearchItems = () => {
    let flag = true;
    const search = this.state.SearchHistory;
    if (search.moduleName == "" && search.actionBy == "" && search.minyear == "" && search.maxyear == "") {
      flag = false;
    }
    return flag;
  }

  SearchHistory1(pgno) {
    if (this.verifySearchItems()) {
      this.state.SearchHistory["pagenumber"] = pgno;
      const { dispatch } = this.props;
      this.setState({ filterShiplist: true });
      dispatch(getHistorySearchlist(this.state.SearchHistory));
    }
    else {
      toast.success("Please select atleast one value", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  ClearSearchField() {
    let param = { ...SearchItem };
    this.setState(
      {
        SearchHistory: param,
      },
      () => {
        this.props.dispatch(getHistorySearchlist(this.state.SearchHistory));
      }
    );
  }

  handleFromDateChange(date) {
    this.state.SearchHistory.minyear = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.state.SearchHistory.nextDateFrom = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    this.state.SearchHistory.maxyear = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.state.SearchHistory.nextDateTo = Moment(
      new Date(Date.parse(date))
    ).format("YYYY-MM-DD");
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  handleRadioButtonChanges(e) {
    this.state.SearchHistory[e.target.name] = this.refs.check_me.checked
      ? "asc"
      : "desc";
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.SearchHistory[nodeName] = e.target.value;
    this.setState({});
  }
  setUpdatedState(value) {
    this.SearchHistory(value);
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    this.setUpdatedState(event.page + 1);
  }

  render() {
    const { showSidePane, mmplHistorySearchResult, t } = this.props;
    const { showClientDetails } = this.state;
    var ServeData = mmplHistorySearchResult?.data;
    console.log("serve", ServeData);
    /*    {
      ServeData.length != 0 ? ( */
    $("#example").DataTable({
      bPaginate: false,
      bFilter: false,
      bInfo: false,
      dataType: "JSON",
      data: ServeData,
      order: [[4, "desc"]],
      columns: [
        { data: "moduleName" },
        { data: "action" },
        { data: "actionDescription" },
        { data: "actionBy" },
        {
          // data: "actionedDate",
          // render: function (data) {
          //   // return Moment(data).format("YYYY-MMM-DD \xa0 HH:mm");
          //   return Moment(data).local().format("YYYY-MMM-DD \xa0 HH:mm");
          // },
          data: "actionedDate",
          render: function (data) {
            const serverTime = Moment.utc(data);
            const localTime = serverTime.local();
        
            return localTime.format("YYYY-MMM-DD \xa0 HH:mm");
          },
        },
      ],
      language: {
        zeroRecords:
          `<center><span style="color:#1a3464;font-weight: 700;font-size: 22px;">${(t("CommonText.NoItem"))}</span></center>`,
      },
      bDestroy: true,
      /*  columnDefs: [
        {
          target: 3, //index of column
          data: "actionedDate",
          render: function (data) {
            return Moment(data).format("YYYY-MMM-DD \xa0\xa0\xa0 HH:mm");
          },
        },
      ], */
    });
    return (
      <div className="full-height">
        <div className="px-4 pt-3">
          {showClientDetails ? (
            <div></div>
          ) : (
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header"
                    style={{ backgroundColor: "white", border: "0px" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("HistoryofActionScreenContent.SearchHistory")}
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row">
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">{t("HistoryofActionScreenContent.ModuleName")}</label>
                        <br></br>

                        <input
                          className="form-control"
                          type="text"
                          name="moduleName"
                          placeholder={t("HistoryofActionScreenContent.ModuleName")}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.SearchHistory.moduleName}
                        ></input>
                      </div>
                      <div className={showSidePane ? "col-lg-6 " : "col-lg-4 "}>
                        <label className="form-label">{t("HistoryofActionScreenContent.ActionBy")}</label>
                        <br></br>

                        <input
                          className="form-control"
                          type="text"
                          name="actionBy"
                          placeholder={t("HistoryofActionScreenContent.ActionBy")}
                          onChange={(e) => this.handleInputChange(e)}
                          value={this.state.SearchHistory.actionBy}
                        ></input>
                      </div>

                      <div
                        className={
                          showSidePane
                            ? "col-lg-6  col-sm-12 col-xs-12"
                            : "col-lg-4  col-sm-12 col-xs-12"
                        }
                      >
                        <div className="row">
                          <div className="col-sm-6">
                            <label className="form-label">{t("ServiceUpdateContent.FromDate")}</label>
                            <br></br>
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                type="text"
                                value={this.state.SearchHistory.nextDateFrom}
                                className="form-control date-picker"
                                placeholder={t("ServiceUpdateContent.FromDate")}
                                name="nextDateFrom"
                              ></input>
                              <DatePicker
                                selected={this.state.SelectedFromDate}
                                onChange={this.handleFromDateChange}
                                open={this.state.fromDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div
                                className="input-group-btn calendar-icon"
                                onClick={this.openFromDatePicker}
                              >
                                <button className="btn btn-default">
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-6  margin">
                            <label className="form-label">{t("ServiceUpdateContent.ToDate")}</label>
                            <br></br>
                            <div
                              className="input-group add-on date datepicker"
                              data-date-format="yyyy-mm-dd"
                            >
                              <input
                                value={this.state.SearchHistory.nextDateTo}
                                type="text"
                                placeholder={t("ServiceUpdateContent.ToDate")}
                                className="form-control date-picker"
                                name="nextDateTo"
                                data-date-format="yyyy-mm-dd"
                              />
                              <DatePicker
                                selected={this.state.SelectedToDate}
                                onChange={this.handleToDateChange}
                                open={this.state.toDatePickerIsOpen}
                                onClickOutside={this.handleBlur}
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="top-end"
                                className="form-control date-picker w-5 hide-date"
                              />
                              <div className="input-group-btn calendar-icon">
                                <button
                                  className="btn btn-default"
                                  onClick={this.openToDatePicker}
                                >
                                  <i className="fa fa-calendar mt-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className={
                          showSidePane ? "col-lg-6 mt-2" : "col-lg-12 mt-2 mb-2"
                        }
                      >
                        <label className="form-label"></label>
                        <br></br>
                        <div
                          className="form-group search-btn-col"
                          style={{ textAlign: "end" }}
                        >
                          <button
                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                            type="submit"
                            onClick={() => this.SearchHistory1(1)}
                          >
                            {" "}
                            {t("content.Search")}{" "}
                          </button>
                          <button
                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                            type="button"
                            onClick={() => this.ClearSearchField()}
                          >
                            {" "}
                            {t("content.Clear")}{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="pt-2">
            <table className="table" id="example">
              <thead className="thead">
                <tr>
                  <th scope="col" width="15%" >
                    {t("HistoryofActionScreenContent.ModuleName")}
                  </th>
                  <th scope="col" width="10%">
                    {t("VendorManagementScreenContent.Action")}{" "}
                  </th>
                  <th scope="col" width="25%" >
                    {t("HistoryofActionScreenContent.ActionDescription")}{" "}
                  </th>
                  <th scope="col" width="30%" className="actionby">
                    {t("HistoryofActionScreenContent.ActionBy")}
                  </th>
                  <th scope="col" className="time">{t("HistoryofActionScreenContent.Timestamp")}</th>
                </tr>
              </thead>
              <tbody className="table-body"></tbody>
            </table>
          </div>
          {mmplHistorySearchResult?.data.length != 0 ? (
            <Paginator
              // first={this.state.first}
              first={(mmplHistorySearchResult?.pagination.currentPage - 1) * mmplHistorySearchResult?.pagination.pageSize}
              rows={mmplHistorySearchResult?.pagination.pageSize}
              totalRecords={
                mmplHistorySearchResult?.pagination.totalcount
                  ? mmplHistorySearchResult?.pagination.totalcount
                  : 0
              }
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          ) : (
            " "
          )}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    mmplHistorySearchResult:
      state.MMPLDashboardReducer.MMPLHistorySearchResult || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(HistoryofActions));
